import { userConstants } from "../_constants";

export function users(state = {}, action) {
  switch (action.type) {
    case userConstants.GETALL_REQUEST:
    case userConstants.REGISTER_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GETALL_SUCCESS:
      return {
        items: action.users,
      };
    case userConstants.DELETE_REQUEST:
      // add 'deleting:true' property to user being deleted
      return {
        ...state,
        items: state.items.map((item) =>
          user.id === action.id ? { ...item, deleting: true } : item
        ),
      };
    case userConstants.DELETE_SUCCESS:
      // remove deleted user from state
      return {
        items: state.items.filter((item) => item.id !== action.id),
      };
    case userConstants.DELETE_FAILURE:
      // remove 'deleting:true' property and add 'deleteError:[error]' property to user
      return {
        ...state,
        items: state.items.map((item) => {
          if (item.id === action.id) {
            // make copy of user without 'deleting:true' property
            const { deleting, ...userCopy } = item;
            // return copy of user with 'deleteError:[error]' property
            return { ...userCopy, deleteError: action.error };
          }

          return user;
        }),
      };
    case userConstants.REGISTER_SUCCESS:
      return {};
    case userConstants.REGISTER_FAILURE:
    case userConstants.GETALL_FAILURE:
    default:
      return state;
  }
}

export function usersForImpersonation(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_ALL_USERS_IMPERSONATION_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_ALL_USERS_IMPERSONATION_SUCCESS:
      return {
        item: action.usersForImpersonation,
      };
    case userConstants.GET_ALL_USERS_IMPERSONATION_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function checkUserName(state = {}, action) {
  switch (action.type) {
    case userConstants.CHECK_DUPLICATE_USERNAME_REQUEST:
      return {
        loading: true,
      };
    case userConstants.CHECK_DUPLICATE_USERNAME_SUCCESS:
      return {
        item: action.newUser,
      };
    case userConstants.CHECK_DUPLICATE_USERNAME_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function user(state = {}, action) {
  switch (action.type) {
    case userConstants.GETUSER_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GETUSER_SUCCESS:
      return {
        item: action.user,
      };
    case userConstants.GETUSER_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
export function updloadPicture(state = {}, action) {
  switch (action.type) {
    case userConstants.UPDATE_PROFILE_REQUEST:
      return {
        loading: true,
      };
    case userConstants.UPDATE_PROFILE_SUCCESS:
      return { item: action.data };
    case userConstants.UPDATE_PROFILE_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
//user profile cards
export function allCardsForUser(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_ALL_CARDS_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_ALL_CARDS_SUCCESS:
      return {
        items: action.cardDetails,
      };
    case userConstants.GET_ALL_CARDS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function listNotifications(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_ALL_NOTIFICATIONS_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_ALL_NOTIFICATIONS_SUCCESS:
      return {
        items: action.notifications,
      };
    case userConstants.GET_ALL_NOTIFICATIONS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function notificationCount(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_NOTIFICATION_COUNT_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_NOTIFICATION_COUNT_SUCCESS:
      return {
        items: action.notificationCount,
      };
    case userConstants.GET_NOTIFICATION_COUNT_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
export function policies(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_ALL_ACCESS_CONTROL_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_ALL_ACCESS_CONTROL_SUCCESS:
      return {
        items: action.allPolicies,
      };
    case userConstants.GET_ALL_ACCESS_CONTROL_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function userPolicies(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_USERS_ACCESS_CONTROL_REQUEST:
    case userConstants.USERS_ACCESS_CONTROL_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_USERS_ACCESS_CONTROL_SUCCESS:
    case userConstants.USERS_ACCESS_CONTROL_SUCCESS:
      return {
        items: action.policiesForUser,
      };
    case userConstants.USERS_ACCESS_CONTROL_FAILURE:
    case userConstants.GET_USERS_ACCESS_CONTROL_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function postPolicies(state = {}, action) {
  switch (action.type) {
    case userConstants.POST_USERS_ACCESS_CONTROL_REQUEST:
      return {
        loading: true,
      };
    case userConstants.POST_USERS_ACCESS_CONTROL_SUCCESS:
      return {
        items: action.postPolicies,
      };
    case userConstants.POST_USERS_ACCESS_CONTROL_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function userTopCards(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_USER_TOP_CARD_INFO_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_USER_TOP_CARD_INFO_SUCCESS:
      return {
        items: action.userTopCards,
      };
    case userConstants.GET_USER_TOP_CARD_INFO_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function userEdited(state = {}, action) {
  switch (action.type) {
    case userConstants.UPDATE_USER_DETAILS_REQUEST:
      return {
        loading: true,
      };
    case userConstants.UPDATE_USER_DETAILS_SUCCESS:
      return {
        items: action.userEdited,
      };
    case userConstants.UPDATE_USER_DETAILS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function userFilters(state = {}, action) {
  switch (action.type) {
    case userConstants.USER_FETCH_FILTER_REQUEST:
      return {
        loading: true,
      };
    case userConstants.USER_FETCH_FILTER_SUCCESS:
      return {
        items: action.filtersUser,
      };
    case userConstants.USER_FETCH_FILTER_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function sessionInfo(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_SESSION_INFO_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_SESSION_INFO_SUCCESS:
      return {
        items: action.sessionInfo,
      };
    case userConstants.GET_SESSION_INFO_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function onboarded(state = {}, action) {
  switch (action.type) {
    case userConstants.ONBOARD_USER_REQUEST:
      return {
        loading: true,
      };
    case userConstants.ONBOARD_USER_SUCCESS:
      return {
        items: action.onboarded,
      };
    case userConstants.ONBOARD_USER_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
//customerDetails
export function customerDetails(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_CUSTOMER_DETAILS_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_CUSTOMER_DETAILS_SUCCESS:
      return {
        items: action.customerDetails,
      };
    case userConstants.GET_CUSTOMER_DETAILS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
//filterList
export function filterList(state = {}, action) {
  switch (action.type) {
    case userConstants.APPLY_FILTER_LIST_REQUEST:
      return {
        loading: true,
      };
    case userConstants.APPLY_FILTER_LIST_SUCCESS:
      return {
        items: action.filterList,
      };
    case userConstants.APPLY_FILTER_LIST_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function loginDetails(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_ALL_LOGIN_DETAILS_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_ALL_LOGIN_DETAILS_SUCCESS:
      return {
        items: action.loginDetails,
      };
    case userConstants.GET_ALL_LOGIN_DETAILS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function loginDetailsTopCards(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_ALL_LOGIN_DETAILS_TOP_CARDS_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_ALL_LOGIN_DETAILS_TOP_CARDS_SUCCESS:
      return {
        items: action.loginDetailsTopCards,
      };
    case userConstants.GET_ALL_LOGIN_DETAILS_TOP_CARDS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function userSessionFilters(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_ALL_USER_SESSION_FILTERS_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_ALL_USER_SESSION_FILTERS_SUCCESS:
      return {
        items: action.userSessionFilters,
      };
    case userConstants.GET_ALL_USER_SESSION_FILTERS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function verifySubscription(state = {}, action) {
  switch (action.type) {
    case userConstants.VERIFY_SUBSCRIPTION_REQUEST:
      return {
        loading: true,
      };
    case userConstants.VERIFY_SUBSCRIPTION_SUCCESS:
      return {
        items: action.verifiedSub,
      };
    case userConstants.VERIFY_SUBSCRIPTION_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function resendToken(state = {}, action) {
  switch (action.type) {
    case userConstants.RESEND_VERIFY_REQUEST:
      return {
        loading: true,
      };
    case userConstants.RESEND_VERIFY_SUCCESS:
      return {};
    case userConstants.RESEND_VERIFY_FAILURE:
      return {};
    default:
      return state;
  }
}
export function setMpin(state = {}, action) {
  switch (action.type) {
    case userConstants.CREATE_MPIN_REQUEST:
      return {
        loading: true,
      };
    case userConstants.CREATE_MPIN_SUCCESS:
      return {
        item: action.mpin,
        reload: true,
      };
    case userConstants.CREATE_MPIN_FAILURE:
      return {};
    default:
      return state;
  }
}
export function shareOverEmail(state = {}, action) {
  switch (action.type) {
    case userConstants.SHARE_OVER_EMAIL_REQUEST:
      return {
        loading: true,
      };
    case userConstants.SHARE_OVER_EMAIL_SUCCESS:
      return {
        item: action.shareOverEmail,
      };
    case userConstants.SHARE_OVER_EMAIL_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function aiNotification(state = {}, action) {
  switch (action.type) {
    case userConstants.AINOTIFICATION_UPDATE_REQUEST:
      return {
        loading: true,
      };
    case userConstants.AINOTIFICATION_UPDATE_SUCCESS:
      return {
        item: action.aiNotification,
        reload: true,
      };
    case userConstants.AINOTIFICATION_UPDATE_FAILURE:
      return {};
    default:
      return state;
  }
}

export function activeUsers(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_ALL_ACTIVE_USERS_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_ALL_ACTIVE_USERS_SUCCESS:
      return {
        items: action.activeUsers,
      };
    case userConstants.GET_ALL_ACTIVE_USERS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function isNewNotificationCount(state = {}, action) {
  switch (action.type) {
    case userConstants.UPDATE_IS_NEW_NOTIFICATION_COUNT_REQUEST:
      return {
        loading: true,
      };
    case userConstants.UPDATE_IS_NEW_NOTIFICATION_COUNT_SUCCESS:
      return {
        item: action.isNewNotificationCount,
      };
    case userConstants.UPDATE_IS_NEW_NOTIFICATION_COUNT_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function notification(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_NOTIFICATION_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_NOTIFICATION_SUCCESS:
      return {
        item: action.notification,
      };
    case userConstants.GET_NOTIFICATION_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function notificationOptions(state = {}, action) {
  switch (action.type) {
    case userConstants.FETCH_NOTIFICATION_OPTIONS_REQUEST:
      return {
        loading: true,
      };
    case userConstants.FETCH_NOTIFICATION_OPTIONS_SUCCESS:
      return {
        items: action.notificationOptions,
      };
    case userConstants.FETCH_NOTIFICATION_OPTIONS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function register(state = {}, action) {
  switch (action.type) {
    case userConstants.REGISTER_COMPANY_REQUEST:
      return {
        loading: true,
      };
    case userConstants.REGISTER_COMPANY_SUCCESS:
      return {
        item: action.response,
      };
    case userConstants.REGISTER_COMPANY_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function isDomain(state = {}, action) {
  switch (action.type) {
    case userConstants.CHECK_DOMAIN_AVAILABILITY_REQUEST:
      return {
        loading: true,
      };
    case userConstants.CHECK_DOMAIN_AVAILABILITY_SUCCESS:
      return {
        item: action.response,
      };
    case userConstants.CHECK_DOMAIN_AVAILABILITY_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function generateOTP(state = {}, action) {
  switch (action.type) {
    case userConstants.GENERATE_EMAIL_OTP_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GENERATE_EMAIL_OTP_SUCCESS:
      return {
        item: action.response,
      };
    case userConstants.GENERATE_EMAIL_OTP_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
export function verifyOTP(state = {}, action) {
  switch (action.type) {
    case userConstants.VERIFY_EMAIL_OTP_REQUEST:
      return {
        loading: true,
      };
    case userConstants.VERIFY_EMAIL_OTP_SUCCESS:
      return {
        item: action.response,
      };
    case userConstants.VERIFY_EMAIL_OTP_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function resendOTP(state = {}, action) {
  switch (action.type) {
    case userConstants.RESEND_EMAIL_OTP_REQUEST:
      return {
        loading: true,
      };
    case userConstants.RESEND_EMAIL_OTP_SUCCESS:
      return {
        item: action.response,
      };
    case userConstants.RESEND_EMAIL_OTP_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
